import { EOU_SUBSCRIBE_API, EOU_PREVIEW_API } from './constants.js';
import { getAllCookies } from './getAllCookies.js';
const emailOnlyUserApiMutation = `
  mutation emailOnlyUserApiMutation(
    $input: SubscribeEmailOnlyUserInput!
  ) {
    subscribeEmailOnlyUser(input: $input) {
      __typename
      ... on SubscribeEmailOnlyUserSuccess {
        dummy
      }
      ... on GenericError {
        message
      }
    }
  }
`;
const postSubscribe = async ({
  email,
  countryCode,
  locale,
  currency,
  productId,
  data,
  onError,
  isProd = false
}) => {
  const _getAllCookies = getAllCookies({
      utm: ''
    }),
    utm = _getAllCookies.utm;
  const _URL = new URL(window.location.href),
    searchParams = _URL.searchParams;
  const getUtmFromUrlOrCookie = key => searchParams.get(key) || utm?.[key] || '';
  try {
    const response = await fetch(isProd ? EOU_SUBSCRIBE_API : EOU_PREVIEW_API, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        query: emailOnlyUserApiMutation,
        operationName: 'emailOnlyUserApiMutation',
        variables: {
          input: {
            email,
            countryCode,
            locale,
            currency,
            productId,
            subscribeMetadata: {
              utmCampaign: getUtmFromUrlOrCookie('utm_campaign'),
              utmContent: getUtmFromUrlOrCookie('utm_content'),
              utmMedium: getUtmFromUrlOrCookie('utm_medium'),
              utmSource: getUtmFromUrlOrCookie('utm_source'),
              utmTerm: getUtmFromUrlOrCookie('utm_term')
            }
          }
        }
      })
    });
    return response.ok;
  } catch (e) {
    onError && onError(e);
    return false;
  }
};
export { postSubscribe };
//# sourceMappingURL=api.js.map
